//#region Imports
import React, { useEffect, useRef, useState } from "react";
//MUI
import { Box, Button, Popover, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import eOpsLogo from "../../images/eops.png";
import excel from "../../images/excel.png";
import mepcoLogo from "../../images/mepcoLogo.png";
import pdf from "../../images/pdf.png";
import print from "../../images/print.png";
import { cfpBaseUrl } from "../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  getName,
  printStamp,
  subdivisionName,
} from "../../services/Functions";
import { internalIconStyles } from "../../style/common";
import "../../style/common.scss";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
//#endregion

const DailyProgressReport = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId } =
    useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode = code;
  const [isLoading, setIsLoading] = React.useState(false);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");

  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [Error, setError] = useState("");
  const [totals, setTotals] = useState({});
  // const [officeCode, setOfficeCode] = useState('');
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("0");
  const [apiData, setApiData] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [newConStatusOptions, setNewConStatusOptions] = useState([]);
  const [colStatusOptions, setColStatusOptions] = useState([]);
  const [conStatusOptions, setConStatusOptions] = useState([]);
  const [cotStatusOptions, setCotStatusOptions] = useState([]);
  const [ddeStatusOptions, setDdeStatusOptions] = useState([]);
  const [instStatusOptions, setInstStatusOptions] = useState([]);
  const [rcStatusOptions, setRconnStatusOptions] = useState([]);
  const [netMeteringStatusOptions, setNetMeteringStatusOptions] = useState([]);
  const [mcStatusOptions, setMcStatusOptions] = useState([]);
  const [OptForSmartMeterStatusOptions, setOptForSmartMeterStatusOptions] =
    useState([]);
  const [CourtOrderStatusOptions, setCourtOrderStatusOptions] = useState([]);

  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);

  const [statusFilter, setStatusFilter] = useState("");
  const [colStatusFilter, setColStatusFilter] = useState("");
  const [statusData, setStatusData] = useState([]); // State to store fetched data
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // const filteredCircles = subDivisions.reduce((acc, curr) => {
  //     if (!acc.some(item => item.circleCode === curr.circleCode)) {
  //         acc.push({ circleCode: curr.circleCode, circleName: curr.circleName });
  //     }
  //     return acc;
  // }, []);

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    boldDomTheadRows(wb.Sheets[wb.SheetNames[0]], tableRef.current, 0);
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${officeName} - From ${dateFrom} - to ${dateTo} - Progress-Report.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };
  const connectionTypes = [
    "Application No.",
    "Applicant Name",
    "Applicant CNIC",
    "Reference No.",
    "Recieved From",
    "Submission Date",
    "Referred To",
    "Status",
    "Remarks",
    "Processed by",
  ];

  // const [categoryName, setcategoryName] = useState('New Connections')

  const getStats = async (officeCode, category, dateFrom, dateTo) => {
  setViewBackdrop(true); 
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      officeCode,
      applicationTypeId: category,
      dateFrom,
      dateTo,
    });

    const requestOptions = {
      method: "POST",
      body: raw,
      headers: myHeaders,
      redirect: "follow",
    };

    const response = await fetch(cfpBaseUrl + "/reports/getServicesReport", requestOptions);
    const result = await response.json();

    if (result.message === "Data Found.") {
      const data = result.data;
      const lastModifiedByList = [
        ...new Set(data.map((item) => item.lastModifiedBy).filter(Boolean)),
      ];
      const registeredByList = [
        ...new Set(data.map((item) => item.createdBy).filter(Boolean)),
      ];

      setTableData(data);
      setLastModifiedByOptions(lastModifiedByList);
      setRegisteredByOptions(registeredByList);
      setDateFromDisplay(result.dateFrom);
      setDateToDisplay(result.dateTo);

    } else if (result.message === "Data not found.") {
      setTableData([]);
      setLastModifiedByOptions([]);
      setRegisteredByOptions([]);
    }

  } catch (error) {
    console.error(error);
  } finally {
    setViewBackdrop(false);
  }
};

  const removeEmptyHeaders = (bodyData) => {
    const cleanedData = [];
    for (let i = 0; i < bodyData.length; i++) {
      const row = bodyData[i];
      if (row.length === 1 && row[0].colSpan === 10 && row[0].content) {
        // Check if next row is also a header or undefined
        if (
          i + 1 >= bodyData.length ||
          (bodyData[i + 1].length === 1 && bodyData[i + 1][0].colSpan === 10)
        ) {
          continue; // Skip this header since it's not followed by valid data
        }
      }
      cleanedData.push(row);
    }
    return cleanedData;
  };
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);

      const title =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
          ? `Daily Progress Report - ${
              category === "0" ? "All Services" : categoryName
            }`
          : `${dateFrom ? convertDate(dateFrom) : "-"} to ${
              dateTo ? convertDate(dateTo) : "-"
            } - ${category === "0" ? "All Services" : categoryName}`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`Progress Report for ${officeName}`, pageWidth / 2, 18, {
        align: "center",
      });
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        {
          content: "S.No",
          styles: { halign: "center", fontStyle: "bold" },
        },
        ...connectionTypes.map((type) => ({
          content: type,
          styles: { halign: "left" },
        })),
        ...(category === "1"
          ? [
              {
                content: "DN Payment Verification Date",
                styles: { halign: "left" },
              },
            ]
          : []),
      ];

      let bodyData = [];
      let dataAvailable = false;

      Object.keys(groupedData).forEach((type) => {
        if (category === "0") {
          bodyData.push([
            {
              content: type,
                colSpan: 11,
              styles: {
                halign: "start",
                fontSize: 10,
                fontStyle: "bold",
                fillColor: [240, 248, 255],
              },
            },
          ]);
        }

        const filteredData = groupedData[type].filter((item) => {
          const matchStatus =
            statusFilter === "" || item.status === statusFilter;
          const matchProcessedBy =
            selectedPerson === "" || item.lastModifiedBy === selectedPerson;
          const matchRegisteredBy =
            selectedPerson1 === "" || item.createdBy === selectedPerson1;
          return matchStatus && matchProcessedBy && matchRegisteredBy;
        });

          let serialNo = 1;
        filteredData.forEach((item) => {
          dataAvailable = true;
          bodyData.push([
              { content: String(serialNo++), styles: { halign: "center" } },
            { content: item.applicationId || "-", styles: { halign: "left" } },
            { content: item.applicantName || "-", styles: { halign: "left" } },
            { content: item.applicantCNIC || "-", styles: { halign: "left" } },
            { content: item.referenceNo || "-", styles: { halign: "left" } },
            {
              content: item.submittedThrough || "-",
              styles: { halign: "left" },
            },
            {
              content: formatDate(item.creationDate) || "-",
              styles: { halign: "left" },
            },
            { content: item.cfcName || "-", styles: { halign: "left" } },
            {
              content: item.status || "-",
              styles: {
                halign: "left",
                fontStyle:
                  item.status === "Approved" || item.status === "Completed"
                    ? "bold"
                    : "normal",
              },
            },
            { content: item.remarks || "-", styles: { halign: "left" } },
            {
              content: item.lastModifiedBy || "-",
              styles: { halign: "cenleftter" },
            },
            {
              content: item.paidDNImageVerifiedDateTime || "-",
              styles: { halign: "left" },
            },
            ...(category === "1"
              ? [
                  {
                    content:
                      item.paidDNImageVerifiedDateTime || "-",
                    styles: { halign: "left" },
                  },
                ]
              : []),
          ]);
        });
      });

      if (!dataAvailable) {
        bodyData = [
          [
            {
              content: "No Data Found.",
              colSpan: 10,
              styles: {
                halign: "center",
                fontSize: 10,
                fontStyle: "bold",
                fillColor: [255, 255, 255],
                textColor: [255, 0, 0],
              },
            },
          ],
        ];
      } else {
        bodyData = removeEmptyHeaders(bodyData);
      }

      const baseColumnStyles = {
        0: { cellWidth: 15 },
        1: { cellWidth: 28 },
        2: { cellWidth: 26 },
        3: { cellWidth: 27 },
        4: { cellWidth: 29 },
        5: { cellWidth: 26 },
        6: { cellWidth: 28 },
        7: { cellWidth: 18 },
        8: { cellWidth: 23 },
        9: { cellWidth: 23 },
      };

      const reducedColumnStyles = {
        0: { cellWidth: 15 },
        1: { cellWidth: 23 },
        2: { cellWidth: 22 },
        3: { cellWidth: 25 },
        4: { cellWidth: 26 },
        5: { cellWidth: 23 },
        6: { cellWidth: 26 },
        7: { cellWidth: 16 },
        8: { cellWidth: 21 },
        9: { cellWidth: 21 },
        10: { cellWidth: 20 },
        11: { cellWidth: 19 },
      };

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: { cellPadding: 3, fontSize: 8, halign: "center" },
        tableWidth: "wrap",
        theme: "striped",
        columnStyles: category === "1" ? reducedColumnStyles : baseColumnStyles,
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(
          `${officeName} - From ${dateFrom} - To ${dateTo} - Progress-Report.pdf`
        );
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  const getDateDifference = (startDate, endDate) => {
    // Convert the date strings to Date objects
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];

    const start = new Date(startDates);
    const end = new Date(endDates);

    // Calculate the difference in time (milliseconds)
    const differenceInTime = end - start;

    // Convert time difference from milliseconds to days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    return differenceInDays;
  };

  const handleRemarksClick = (event, remarks) => {
    if (remarks && remarks.trim() !== "") {
      // Only show popover if remarks have a value
      setAnchorEl(event.currentTarget); // Set the target element for Popover
      setSelectedRemarks(remarks);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const groupedData = tableData.reduce((acc, item) => {
    const type = item.applicationType || "Unknown Type"; // Use applicationType for grouping

    if (!acc[type]) acc[type] = [];
    acc[type].push(item);

    return acc;
  }, {});

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleColStatusChange = (e) => {
    setColStatusFilter(e.target.value);
  };

  const fetchData = async (token) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "/reports/getStatusNameOfAllService",
        requestOptions
      );

      if (response.ok) {
        // Check for HTTP status 200
        const result = await response.json();

        if (result?.message === "Data Found." && result?.data) {
          const data = result.data;

          // Extract status options for each dropdown
          const newConStatus = data
            .map((item) => item.newConProgStatusName)
            .filter(Boolean);
          const colStatus = data
            .map((item) => item.cOLProgStatusName)
            .filter(Boolean);
          const conStatus = data
            .map((item) => item.cONProgStatusName)
            .filter(Boolean);
          const cotStatus = data
            .map((item) => item.cOTProgStatusName)
            .filter(Boolean);
          const ddeStatus = data
            .map((item) => item.dDEProgStatusName)
            .filter(Boolean);
          const instStatus = data
            .map((item) => item.instProgStatusName)
            .filter(Boolean);
          const RcStatus = data
            .map((item) => item.reConProgStatusName)
            .filter(Boolean);
          const MeterChangeStatus = data
            .map((item) => item.cOMRProgStatusName)
            .filter(Boolean);
          const OptForSmartMeterStatus = data
            .map((item) => item.oFSMProgStatusName)
            .filter(Boolean);
          // const nMeteringStatus = data.map(item => item.reConProgStatusName).filter(Boolean);
          // const CourtOrderStatus = data.map(item => item.reConProgStatusName).filter(Boolean);

          // Set the options for each dropdown
          setNewConStatusOptions(newConStatus);
          setColStatusOptions(colStatus);
          setConStatusOptions(conStatus);
          setCotStatusOptions(cotStatus);
          setDdeStatusOptions(ddeStatus);
          setInstStatusOptions(instStatus);
          setRconnStatusOptions(RcStatus);
          setMcStatusOptions(MeterChangeStatus);
          setOptForSmartMeterStatusOptions(OptForSmartMeterStatus);
          // setNetMeteringStatusOptions(OptForSmartMeterStatus);
          // setCourtOrderStatusOptions(OptForSmartMeterStatus);
        }
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  useEffect(() => {
    fetchData(token);
  }, [token]);

  const hasFilteredData = Object.values(groupedData).some((group) =>
    group.some((item) => {
      const matchStatus = statusFilter === "" || item.status === statusFilter;
      const matchProcessedBy =
        selectedPerson === "" || item.lastModifiedBy === selectedPerson;
      const matchRegisteredBy =
        selectedPerson1 === "" || item.createdBy === selectedPerson1;
      return matchStatus && matchProcessedBy && matchRegisteredBy;
    })
  );

  const handleProcessedChange = (e) => {
    const selected = e.target.value;
    setSelectedPerson(selected);
    console.log("Selected person:", selected);
  };
  const handleRegisteredChange = (e) => {
    const selected = e.target.value;
    setSelectedPerson1(selected);
    console.log("Selected person1:", selected);
  };

  const currentFilters = {
    officeCode,
    category,
    dateFrom,
    dateTo,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [dateFrom, officeCode, category, dateFrom, dateTo]);

  const handleGoClick = () => {
    getStats(officeCode, category, dateFrom, dateTo);

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };
  
  return (
    <>
      {/* Applications Table */}
      <Box className="form-box">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Box className="application-table" style={{ marginRight: "10px" }}>
            <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
              Progress Report
            </h3>
            <div className="div-datagrid">
              <div className="reports-container">
                <div
                  className="filter-fields"
                  style={{
                    width: "75%",
                    justifyContent: "flex-start",
                    gap: "15px",
                  }}
                >
                  <div className="field-container">
                    <Typography className="field-label"> Date From</Typography>
                    <input
                      type="date"
                      className="date-field"
                      value={dateFrom}
                      onChange={(e) => {
                        setDateFrom(e.target.value);
                      }}
                    />
                  </div>
                  <div className="field-container">
                    <Typography className="field-label"> Date To</Typography>
                    <input
                      type="date"
                      className="date-field"
                      value={dateTo}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => {
                        setDateTo(e.target.value);
                      }}
                    />
                  </div>
                  {/* Circle Field (Auto-selected) */}
                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedCompanyCode}
                        onChange={(e) => {
                          handleChangeCompany(e);
                        }}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={circleCode || ""}
                        onChange={(e) => {
                          handleCircleChange(e);
                        }}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedDivision || ""}
                        onChange={(e) => {
                          handleDivisionChange(e);
                        }}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedSubDivision || ""}
                        onChange={(e) => {
                          handleSubDivisionChange(e);
                        }}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="field-container">
                    <Typography className="field-label">Category</Typography>
                    <select
                      value={category}
                      className="dropdown-field"
                      style={{ backgroundColor: "white" }}
                      onChange={(e) => {
                        setCategory(e.target.value);
                        const selectedOption =
                          e.target.options[e.target.selectedIndex].text;
                        setStatusFilter("");
                        setCategoryName(
                          selectedOption === "All" ? "" : selectedOption
                        );
                      }}
                    >
                      <option value={0}>All</option>
                      <option value={1}>New Connections</option>
                      <option value={2}>Change of Load</option>
                      <option value={3}>Change of Name</option>
                      <option value={4}>Change of Tariff</option>
                      {/* <option value={5}>Meter Change Requests</option> */}
                      {/* <option value={6}>Opt For Smart Meter</option> */}
                      <option value={7}>Due Date Extensions</option>
                      <option value={8}>Bill Installments</option>
                      {/* <option value={10}>Net Metering</option> */}
                      {/* <option value={12}>Court Order</option> */}
                      <option value={13}>Re-Connection</option>
                    </select>
                  </div>
                  {category === "0" && (
                    <div className="field-container">
                      <Typography></Typography>
                      <select
                        style={{ backgroundColor: "white", display: "none" }}
                        className="dropdown-field"
                      >
                        <option value=""></option>
                      </select>
                    </div>
                  )}
                  {category === "1" && (
                    <div className="field-container">
                      <Typography className="field-label">Status</Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {newConStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {category === "2" && (
                    <div className="field-container">
                      <Typography className="field-label">Status </Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {colStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {category === "3" && (
                    <div className="field-container">
                      <Typography className="field-label">Status </Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {conStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {category === "4" && (
                    <div className="field-container">
                      <Typography className="field-label">Status </Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {cotStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {category === "7" && (
                    <div className="field-container">
                      <Typography className="field-label">Status </Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {ddeStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {category === "8" && (
                    <div className="field-container">
                      <Typography className="field-label">Status </Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {instStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {category === "13" && (
                    <div className="field-container">
                      <Typography className="field-label">Status </Typography>
                      <select
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                        style={{ backgroundColor: "white" }}
                        className="dropdown-field"
                      >
                        <option value="">All</option>
                        {rcStatusOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {/* {category === "6" && (
                                        <div className="field-container">
                                            <Typography className="field-label">Status </Typography>
                                            <select
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                style={{ backgroundColor: "white" }}
                                                className="dropdown-field"
                                            >
                                                <option value="">All</option>
                                                {OptForSmartMeterStatusOptions.map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                    {category === "5" && (
                                        <div className="field-container">
                                            <Typography className="field-label">Status </Typography>
                                            <select
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                style={{ backgroundColor: "white" }}
                                                className="dropdown-field"
                                            >
                                                <option value="">All</option>
                                                {mcStatusOptions.map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )} */}
                  {/* {category === "12" && (
                                        <div className="field-container">
                                            <Typography className="field-label">Status </Typography>
                                            <select
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                style={{ backgroundColor: "white" }}
                                                className="dropdown-field"
                                            >
                                                <option value="">All</option>
                                                {rcStatusOptions.map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )} */}
                  {/* {category === "10" && (
                                        <div className="field-container">
                                            <Typography className="field-label">Status </Typography>
                                            <select
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                style={{ backgroundColor: "white" }}
                                                className="dropdown-field"
                                            >
                                                <option value="">All</option>
                                                {rcStatusOptions.map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )} */}

                  {/* <div className='field-container'>
                                        <button onClick={handleClick} className='primary-button'>
                                            <SearchIcon id="searchBtn" sx={{ color: 'white' }} />
                                        </button>
                                    </div> */}
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "10px" }}
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    Go
                  </Button>

                 
                </div>

                <div
                  className="export-button-container"
                  style={{ width: "25%" }}
                >

                   {registeredByOptions?.length > 0 && (
                    <div>
                      <Typography className="field-label">Registered by:</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white",
                        padding: "5px 10px",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        width: "150px", }}
                        id="lastModifiedBy"
                        value={selectedPerson1}
                        onChange={handleRegisteredChange}
                      >
                        <option value="">Select a person</option>
                        {registeredByOptions.map((person, index) => (
                          <option key={index} value={person}>
                            {person}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {lastModifiedByOptions?.length > 0 && (
                    <div style={{ marginLeft: "15px" }}>
                      <Typography className="field-label">Processed by:</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white",
                        padding: "5px 10px",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        width: "150px", }}
                        id="lastModifiedBy"
                        value={selectedPerson}
                        onChange={handleProcessedChange}
                      >
                        <option value="">Select a person</option>
                        {lastModifiedByOptions.map((person, index) => (
                          <option key={index} value={person}>
                            {person}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                   <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="table-container" style={{ marginBottom: "40px" }}>
                <div id="pdf-table">
                  <div
                    style={{
                      maxHeight: "740px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <table
                      className="table"
                      ref={tableRef}
                      style={{
                        marginBottom: "40px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        <tr
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 3,
                          }}
                        >
                          <th
                            colSpan={category === "1" ? "16" : "15"}
                            style={{
                              fontSize: "20px",
                              borderBottom: "2px solid white",
                              textAlign: "center",
                              backgroundColor: "#d5e5ff",
                              color: "black",
                            }}
                          >
                            {dateFrom &&
                            dateTo &&
                            convertDate(dateFrom) === convertDate(dateTo)
                              ? `Daily Progress Report for (${officeName}) - ${
                                  category === "0"
                                    ? "All Services"
                                    : categoryName
                                }`
                              : `Progress Report for (${officeName}) from ${
                                  dateFrom ? convertDate(dateFrom) : "-"
                                } to ${dateTo ? convertDate(dateTo) : "-"} - ${
                                  category === "0"
                                    ? "All Services"
                                    : categoryName
                                }`}
                          </th>
                        </tr>
                        <tr
                          style={{
                            position: "sticky",
                            top: "37px",
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          <th
                            style={{
                              width: `${
                                100 /
                                (connectionTypes.length +
                                  1 +
                                  (category === "1" ? 1 : 0))
                              }%`,
                              textAlign: "center",
                              border: "5px solid white",
                              backgroundColor: "#eeeff1",
                              color: "black",
                              fontSize: "14px",
                              fontWeight: "bold",
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            }}
                          >
                            S.No
                          </th>
                          {connectionTypes.map((type, index) => (
                            <th
                              key={index}
                              style={{
                                width: `${
                                  100 /
                                  (connectionTypes.length +
                                    1 +
                                    (category === "1" ? 1 : 0))
                                }%`,
                                textAlign: "left",
                                border: "5px solid white",
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "14px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              {type}
                            </th>
                          ))}
                          {category === "1" && (
                            <th
                              style={{
                                width: `${
                                  100 /
                                  (connectionTypes.length +
                                    1 +
                                    (category === "1" ? 1 : 0))
                                }%`,
                                textAlign: "left",
                                border: "5px solid white",
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "14px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              DN Payment Verification Date
                            </th>
                          )}
                        </tr>
                      </thead>
                      {/* <tbody>
                                                {Object.keys(groupedData).length === 0 ? (
                                                    <tr>
                                                        <td colSpan={category === "1" ? "11" : "10"} style={{ textAlign: "center", padding: "10px", fontWeight: "bold", color: "red" }}>
                                                            {Error}
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    Object.keys(groupedData).map((type, index) => {
                                                        const filteredData = groupedData[type].filter((item) =>
                                                            statusFilter === "" || item.status === statusFilter
                                                        );

                                                        return (
                                                            <React.Fragment key={index}>
                                                                {category === "0" && (
                                                                    <tr style={{ backgroundColor: "white" }}>
                                                                        <td colSpan={category === "1" ? "11" : "10"} style={{ height: "10px" }}></td>
                                                                    </tr>
                                                                )}

                                                                {category === "0" && (
                                                                    <tr>
                                                                        <td colSpan={category === "1" ? "11" : "10"} style={{
                                                                            textAlign: "start",
                                                                            fontWeight: "bold",
                                                                            fontSize: "16px",
                                                                            padding: "10px",
                                                                            backgroundColor: "#f0f8ff",
                                                                        }}>
                                                                            {type}
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                                {filteredData.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan={category === "1" ? "11" : "10"} style={{
                                                                            textAlign: "center",
                                                                            padding: "10px",
                                                                            fontWeight: "bold",
                                                                            color: "red",
                                                                        }}>
                                                                            No data found.
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    filteredData.map((item, id) => (
                                                                        <tr key={id} style={{ background: 'white', borderBottom: "1px solid #ccc" }}>
                                                                            <td style={{ textAlign: "left" }}>{item.applicationId || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.applicantName || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.applicantCNIC || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.referenceNo || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.submittedThrough || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{formatDate(item.creationDate) || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.cfcName || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.status || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.remarks || "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{item.lastModifiedBy || "-"}</td>
                                                                            {category === "1" && (
                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {formatDate(item.paidDNImageVerifiedDateTime) || "-"}
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                            </tbody> */}
                      <tbody>
                        {!hasFilteredData ? (
                          <tr>
                            <td
                              colSpan={category === "1" ? "12" : "11"}
                              style={{
                                textAlign: "center",
                                padding: "10px",
                                fontWeight: "bold",
                                color: "red",
                              }}
                            >
                              {Error || "No Data Found"}
                            </td>
                          </tr>
                        ) : (
                          Object.keys(groupedData).map((type, index) => {
                            const filteredData = groupedData[type].filter(
                              (item) => {
                                const matchStatus =
                                  statusFilter === "" ||
                                  item.status === statusFilter;
                                const matchProcessedBy =
                                  selectedPerson === "" ||
                                  item.lastModifiedBy === selectedPerson;
                                const matchRegisteredBy =
                                  selectedPerson1 === "" ||
                                  item.createdBy === selectedPerson1;
                                return (
                                  matchStatus &&
                                  matchProcessedBy &&
                                  matchRegisteredBy
                                );
                              }
                            );

                            if (filteredData.length === 0) return null;

                            return (
                              <React.Fragment key={index}>
                                {category === "0" && (
                                  <tr style={{ backgroundColor: "white" }}>
                                    <td
                                      colSpan={category === "1" ? "12" : "11"}
                                      style={{ height: "10px" }}
                                    ></td>
                                  </tr>
                                )}
                                {category === "0" && (
                                  <tr>
                                    <td
                                      colSpan={category === "1" ? "12" : "11"}
                                      style={{
                                        textAlign: "start",
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        padding: "10px",
                                        backgroundColor: "#f0f8ff",
                                      }}
                                    >
                                      {type}
                                    </td>
                                  </tr>
                                )}

                                {filteredData.map((item, id) => (
                                  <tr
                                    key={id}
                                    style={{
                                      background: "white",
                                      borderBottom: "1px solid #ccc",
                                    }}
                                  >
                                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                      {id + 1}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.applicationId || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.applicantName || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.applicantCNIC || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.referenceNo || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.submittedThrough || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {formatDate(item.creationDate) || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.cfcName || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.status || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.remarks || "-"}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.lastModifiedBy || "-"}
                                    </td>
                                    {category === "1" && (
                                      <td style={{ textAlign: "left" }}>
                                        {item.paidDNImageVerifiedDateTime|| "-"}
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              </React.Fragment>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Box>
      {/* Popover for showing full Remarks */}
      {selectedRemarks && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableRestoreFocus
        >
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" sx={{ fontSize: "17px" }}>
              Remarks :
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{selectedRemarks}</Typography>
          </div>
        </Popover>
      )}
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default DailyProgressReport;
